// extracted by mini-css-extract-plugin
export default {"wrapper":"ListInfoItem_wrapper__43qb3","name":"ListInfoItem_name__DGe3g","value":"ListInfoItem_value__Ffq9I","wrapValue":"ListInfoItem_wrapValue__DSSer"};